import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage/Pages";
import PageEksplore from "./LandingPage/Pages/explore/pageEksplore";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/explore" element={<PageEksplore />} />
      </Routes>
    </Router>
  );
};

export default App;
